<pp-error-box
  ppOpeningMessageKey="fleet_sharing_error_description_1"
  ppClosingMessageKey="fleet_sharing_error_description_2"
  [ppErrors]="errorMessages"
></pp-error-box>
